import { ReactNode } from 'react';
import styles from '../styles/questions.module.css';
import { useSurveyContext } from '../context/useSurveryContext';
import { useIdQuestion } from '../hooks/useIdQuestion';
import logo from '../../../assets/png/logo.png';
interface QuestionContentProps {
	children?: ReactNode;
}

export default function QuestionContent({ children }: QuestionContentProps) {
	const { termsAccepted } = useSurveyContext();
	const id = useIdQuestion(); //className="w-full max-w-xl"
	return (
		<div className={styles['encuesta-wrapper']}>
			<div>
				{id !== '00008' && !termsAccepted && (
					<div className={styles['logo-wrapper']}>
						<img src={logo} alt="Logo" className={styles.logo} />
					</div>
				)}
				<div className={styles.content}>{children}</div>
			</div>
		</div>
	);
}
